import React from 'react'
import { requestRoot } from 'services/ReviewService'
import connect from 'front-end-core/decorators/connect'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const AccordionWrapper = ({ flavour, ...props }) => {
  const cxNames = {
    groupHeader: {
      onHoverColor: `hover-bg-flavour-${flavour}`,
      depthStyle: (depth) => {
        switch (depth) {
          case 1:
            return `bg-white b--flavour-${flavour} hover-bg-flavour-${flavour}`
          case 2:
            return `bg-flavour-${flavour} b--flavour-${flavour}`
          default:
            return `bg-twilight-grey ${flavour} b--flavour-${flavour}`
        }
      },
      iconDepthStyle: () => 'cadet-blue'
    },
    borderColor: `b--flavour-${flavour}`,
    content: {
      divider: `btc--flavour-${flavour}`
    },
    contentHeader: {
      headerBackground: 'bg-white'
    }
  }
  return <AccordionWrapperContainer {...{ flavour, cxNames, ...props }} />
}

export default connect(
  ({ flavour, sectionId, selectedIds, aol }) => ({ group: requestRoot({ flavour, sectionId, selectedIds, aol }) })
)(AccordionWrapper)
